const listeners = new Set();
let toastId = 0;

function normalizeInput(variant, title, description, options = {}) {
  if (typeof title === 'object' && title !== null) {
    return { variant, duration: 4500, ...title };
  }
  return { variant, title, description, duration: 4500, ...options };
}

function publish(payload) {
  const id = ++toastId;
  listeners.forEach((listener) => {
    listener({ ...payload, id });
  });
}

export const toast = {
  success(title, description, options) {
    publish(normalizeInput('success', title, description, options));
  },
  error(title, description, options) {
    publish(normalizeInput('error', title, description, { duration: 6000, ...options }));
  },
  info(title, description, options) {
    publish(normalizeInput('info', title, description, options));
  },
};

export function subscribeToToasts(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
